import { collection, doc, getDoc, getDocs, updateDoc } from "@firebase/firestore";
import { db } from "../../connection";

// milestone3 has no entry here — its status is derived live from
// website/{groupId}.isPublished (see getWebsiteConfig).
const REFERRAL_COUNT = 5;

// referrals is a map keyed by index, not an array — Firestore can't
// dot-path-update an array element, and name/confirmed (group admin) vs
// verifiedBySuperAdmin (super admin) need independent writes.

export const fbGetReferrals = (groupId) => {
  const docRef = doc(db, "group", groupId);
  return getDoc(docRef).then((snap) => {
    const saved = snap.data()?.milestones?.milestone1?.referrals || {};
    return Array.from({ length: REFERRAL_COUNT }, (_, i) => ({
      name: saved[i]?.name || "",
      confirmed: saved[i]?.confirmed || false,
      verifiedBySuperAdmin: saved[i]?.verifiedBySuperAdmin || false,
    }));
  });
};

export const fbConfirmReferral = (groupId, index, name) => {
  const docRef = doc(db, "group", groupId);
  return updateDoc(docRef, {
    [`milestones.milestone1.referrals.${index}.name`]: name,
    [`milestones.milestone1.referrals.${index}.confirmed`]: true,
  });
};

export const fbSetReferralVerified = (groupId, index, verifiedBySuperAdmin) => {
  const docRef = doc(db, "group", groupId);
  return updateDoc(docRef, {
    [`milestones.milestone1.referrals.${index}.verifiedBySuperAdmin`]: verifiedBySuperAdmin,
  });
};

// Resets a misfilled slot so the group admin can re-enter it.
export const fbClearReferral = (groupId, index) => {
  const docRef = doc(db, "group", groupId);
  return updateDoc(docRef, {
    [`milestones.milestone1.referrals.${index}.name`]: "",
    [`milestones.milestone1.referrals.${index}.confirmed`]: false,
    [`milestones.milestone1.referrals.${index}.verifiedBySuperAdmin`]: false,
  });
};

// ── Milestone 02: Amplify the Brand ─────────────────────────────────────────

export const fbGetAmplifyData = (groupId) => {
  const docRef = doc(db, "group", groupId);
  return getDoc(docRef).then((snap) => snap.data()?.milestones?.milestone2 ?? {});
};

export const fbSaveAmplifyData = (groupId, data) => {
  const docRef = doc(db, "group", groupId);
  const updates = {};
  if (data.announcement !== undefined) {
    updates["milestones.milestone2.announcement"] = data.announcement;
  }
  if (data.logoConfirmed !== undefined) {
    updates["milestones.milestone2.logoConfirmed"] = data.logoConfirmed;
  }
  return updateDoc(docRef, updates);
};

export const fbSetMilestone2Verified = (groupId, verifiedBySuperAdmin) => {
  const docRef = doc(db, "group", groupId);
  return updateDoc(docRef, {
    "milestones.milestone2.verifiedBySuperAdmin": verifiedBySuperAdmin,
  });
};

// ── Super admin: review queue ───────────────────────────────────────────────

export const fbGetGroupsForMilestoneReview = () => {
  return getDocs(collection(db, "group")).then((snap) =>
    snap.docs
      .map((d) => ({ id: d.id, groupName: d.data().groupName, milestones: d.data().milestones }))
      .filter((data) => !!data.milestones),
  );
};
